import { PortfolioModel } from '@/shared/models/portfolio-model'

export interface HomeState {
  offers: PortfolioModel[]
  organisations: PortfolioModel[]
}

export const EmptyHomeState: HomeState = {
  offers: [],
  organisations: [],
}
